export const sortItemsParenthesisLast = (items, getName = item => item?.name || item || '') => {
  if (!items) return [];

  return [...items].sort((a, b) => {
    const aIsParenthesis = /\(.*\)/.test(getName(a));
    const bIsParenthesis = /\(.*\)/.test(getName(b));

    if (aIsParenthesis && !bIsParenthesis) return 1;
    if (!aIsParenthesis && bIsParenthesis) return -1;
    return 0;
  });
};

export const filterItemsByName = (getName = item => item?.name || item || '') => ({ item, inputValue }) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  getName(item).toLowerCase().includes((inputValue || '').toLowerCase());
